export { StyledSlider } from "./StyledSlider";
